import React from 'react';
import LiveRatesSection from '../components/LiveRatesSection';
import RatePriceChart from '../components/RatePriceChart';
import JewelleryPriceCalculator from '../components/JewelleryPriceCalculator';
import MarketingOfferBanner from '../components/MarketingOfferBanner';
import TrustSection from '../components/TrustSection';
import StoreLocatorSection from '../components/StoreLocatorSection';
import { Sparkles, ShieldCheck, Award, HelpCircle } from 'lucide-react';

export default function LiveRatesPage() {
  return (
    <div style={{ backgroundColor: '#f1f3f6', minHeight: '100vh', paddingBottom: '3rem' }}>
      
      {/* 1. Page Header */}
      <div style={{
        background: 'linear-gradient(135deg, #1e3a8a 0%, #2874f0 100%)',
        color: '#ffffff',
        padding: '2.5rem 1rem 2rem',
        textAlign: 'center'
      }}>
        <div className="container" style={{ maxWidth: '1240px', margin: '0 auto' }}>
          <div style={{
            display: 'inline-flex',
            alignItems: 'center',
            gap: '0.4rem',
            background: 'rgba(255, 255, 255, 0.15)',
            border: '1px solid rgba(255, 255, 255, 0.25)',
            borderRadius: '20px',
            padding: '0.25rem 0.8rem',
            fontSize: '0.74rem',
            fontWeight: 800,
            textTransform: 'uppercase',
            letterSpacing: '0.06em',
            marginBottom: '0.6rem'
          }}>
            <Sparkles size={13} color="#ffe500" />
            <span>IBJA Benchmark Bullion Portal</span>
          </div>
          <h1 style={{
            margin: '0 0 0.5rem',
            fontSize: 'clamp(1.6rem, 3vw, 2.4rem)',
            fontWeight: 800,
            fontFamily: "'Playfair Display', serif, Georgia"
          }}>
            Live Gold & Silver Rates Today in INR
          </h1>
          <p style={{
            margin: 0,
            fontSize: '0.92rem',
            color: '#dbeafe',
            maxWidth: '640px',
            margin: '0 auto'
          }}>
            Real-time bullion market benchmark prices for 24K, 22K, 18K Gold and 999 Fine Silver. Automatically refreshed with full price breakdown.
          </p>
        </div>
      </div>

      {/* 2. Marketing / Special Ad Offer Banner */}
      <MarketingOfferBanner />

      {/* 3. Live Rate Cards (24K, 22K, 18K, 999 Silver) */}
      <LiveRatesSection />

      {/* 4. Interactive Price Trend Chart */}
      <RatePriceChart />

      {/* 5. Professional Jewellery Price Calculator */}
      <JewelleryPriceCalculator />

      {/* 6. BIS Hallmark Trust & Testing Pillars */}
      <TrustSection />

      {/* 7. Store Locator */}
      <StoreLocatorSection />

    </div>
  );
}
